import React from 'react';
import {MdMoreHoriz} from 'react-icons/md';
import {IconButton, Menu, MenuButton, MenuItem, MenuList} from 'components/ui/chakra';

export interface RowActionMenuItem {
	label: React.ReactNode;
	onClick?: () => void;
	icon?: React.ReactNode;
	isDisabled?: boolean;
	hidden?: boolean;
	tone?: 'default' | 'danger';
}

interface RowActionMenuProps {
	ariaLabel?: string;
	items: RowActionMenuItem[];
}

const RowActionMenu = ({ariaLabel = 'Open row actions', items}: RowActionMenuProps) => {
	const visibleItems = items.filter((item) => !item.hidden);

	if (visibleItems.length === 0) {
		return (
			<IconButton
				aria-label={ariaLabel}
				borderRadius='full'
				h='2.25rem'
				icon={<MdMoreHoriz />}
				intent='tertiary'
				isDisabled
				minW='2.25rem'
				size='sm'
			/>
		);
	}

	const hasEnabledItem = visibleItems.some((item) => !item.isDisabled);

	return (
		<Menu positioning={{placement: 'bottom-end'}}>
			<MenuButton asChild>
				<IconButton
					aria-label={ariaLabel}
					borderRadius='full'
					h='2.25rem'
					icon={<MdMoreHoriz />}
					intent='tertiary'
					isDisabled={!hasEnabledItem}
					minW='2.25rem'
					size='sm'
				/>
			</MenuButton>
			<MenuList minW='12rem'>
				{visibleItems.map((item) => (
					<MenuItem
						key={typeof item.label === 'string' ? item.label : ariaLabel}
						color={item.tone === 'danger' ? 'red.600' : undefined}
						icon={item.icon}
						onClick={item.onClick}
						disabled={item.isDisabled}
						_hover={
							item.tone === 'danger'
								? {
										bg: 'red.50',
										color: 'red.700',
									}
								: undefined
						}
					>
						{item.label}
					</MenuItem>
				))}
			</MenuList>
		</Menu>
	);
};

export default RowActionMenu;
